import { render, staticRenderFns } from "./blog-3.vue?vue&type=template&id=1ea96dda&scoped=true"
import script from "./blog-3.vue?vue&type=script&lang=js"
export * from "./blog-3.vue?vue&type=script&lang=js"
import style0 from "./blog-3.vue?vue&type=style&index=0&id=1ea96dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea96dda",
  null
  
)

export default component.exports